import { Component, OnInit } from '@angular/core';
import { Approved } from 'src/app/service/modal/approved';
import { ActivatedRoute } from '@angular/router';
import { MailViewService } from 'src/app/service/apiservice/mailview.service';
import { Globals } from '../../../globals';
declare function info_noti(msg:any):any;
@Component({
  selector: 'app-trash-view-mobile',
  templateUrl: './trash-view-mobile.component.html',
  styleUrls: ['./trash-view-mobile.component.css']
})
export class TrashViewMobileComponent implements OnInit {

  mailId: number;
  ViewData: Approved = new Approved();

  constructor(private route: ActivatedRoute, private _mailService: MailViewService,private global:Globals) { }

  ngOnInit() {
    this.global.afterRefreshPageSetToken();
    this.route.params.subscribe(params => this.mailId = params['id']);
    this._mailService.GetCurrentMail(this.mailId)
      .subscribe((response) => {
        Object.assign(this.ViewData, response);
      }, error => {
           info_noti(error);
        })
  }

}
